export default "__VITE_ASSET__oLvTOCct__"